var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.header.classes},[(_vm.value)?_c('v-btn',{attrs:{"icon":"","href":_vm.value,"target":"_blank"}},[_c('v-icon',[_vm._v("assignment")])],1):_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("remove")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }